// Assets Manager Class
// Handles business logic and state management for the assets section

import { Manager, logger } from '../../../core';

export class AssetsManager extends Manager {
  constructor() {
    super();

    this.isLoading = false;
  }

  async initGlobalVariables() {
    logger.log(
      { tags: 'manager|assets|init', color1: 'cyan' },
      'Initializing AssetsManager global variables'
    );
  }

  async initStates() {
    logger.log(
      { tags: 'manager|assets|init', color1: 'cyan' },
      'Initializing AssetsManager states'
    );
  }
}
